import React, { Component } from "react";
import { apiCall_domain } from "../api";
import Header from "../header";
import { createGlobalStyle } from "styled-components";
import axios from "axios";

// const style = {
//   background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
//   borderRadius: 3,
//   border: 0,
//   color: "white",
//   padding: "0 30px",
//   boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
// };

class Refferal extends Component {
  state = {
    VendorHeader: true,
    referralCode: "",
    showApps: false,
  };
  componentDidMount() {
    const Headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };

    axios
      .get(`${apiCall_domain}/customer/auth/share_code`, {
        headers: Headers,
      })
      .then((res) => {
        const searchParam = new URLSearchParams(new URL(res.data).search);
        const referralCode = searchParam.get("referral_code");
        this.setState({ referralCode });
      });
  }
  handleShare = () => {
    if (navigator.share) {
      const shareData = {
        title: "کد تخفیف",
        text: this.state.referralCode,
      };
      navigator.share(shareData);
    }
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9
    }`;
    return (
      <>
        <GlobalStyles />
        <Header
          showSearchBar={true}
          title={"معرفی به دوستان"}
          VendorHeader={this.state.VendorHeader}
        />
        <div className="RefferalCom">
          <div className="img">
            <img src="/public/assets/icons/GIFT2.svg" alt="pic" />
          </div>
          <div className="text">
            با معرفی کاچار به 5 نفر از دوستان خود از کد تخفیف 10000 تومان بهره
            مند شوید .
          </div>
          <div className="RefferaCode">{this.state.referralCode}</div>
        </div>
        <button onClick={this.handleShare} className="ShareReferalCode">
          اشتراک گذاری
        </button>
        <p class="result"></p>
      </>
    );
  }
}
export default Refferal;
